import { AfterViewInit, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { END_DATE_GREATER, PaymentStatusOption, SELECT_BOTH_DATES } from '@shared/constant/shared.constant';
import { FilterData, ParkingLot } from '@core/models/api-response.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SuperAdminService } from '@core/services/super-admin.service';
import { PaymentStatus } from '@core/models/booking.model';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-user-crm-filter-modal',
  templateUrl: './user-crm-filter-modal.component.html',
  styleUrls: ['./user-crm-filter-modal.component.scss']
})
export class UserCrmFilterModalComponent implements AfterViewInit, OnInit {
  readonly destroyRef = inject(DestroyRef);
  filterFormGroup: FormGroup;
  companyId: string;
  parkingLotByStatesListWithAll: ParkingLot[] = [];
  parkingLotByStatesList: ParkingLot[] = [];
  selectPaymentStatus: { name: string; value: PaymentStatus }[] = PaymentStatusOption;
  modalOpened: boolean = false;
  filterDataRecieved: FilterData;
  minEndDate: Date | null = null;
  errorMessage:string = '';

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly superAdminService: SuperAdminService,
    private readonly config: DynamicDialogConfig,
    private readonly ref: DynamicDialogRef,
  ) {}

  ngAfterViewInit() {
    this.modalOpened = true;
  }

  ngOnInit() {
    this.companyId = this.config?.data?.companyId;
    this.filterDataRecieved = this.config?.data?.filterData
    this.assignFilterFormGroup();
    this.filterRecievedDataPatchValue();
    if (!this.filterDataRecieved) {
      this.filterFormGroup.get('paymentStatus').setValue(PaymentStatus.All);
    }
    this.getParkingLotByStatesName();

    this.filterFormGroup.get('startdate')?.valueChanges.subscribe(() => {
      this.updateMinEndDate();
    });

  }
;
  assignFilterFormGroup() {
    this.filterFormGroup = this.formBuilder.group({
      startdate: [''],
      enddate: [''],
      parkingLot: ['',Validators.required],
      invoiceNumber: [''],
      paymentStatus: ['']
    })
  }

  filterRecievedDataPatchValue(){
    if( this.filterDataRecieved){
      this.filterFormGroup.patchValue({
        startdate: this.filterDataRecieved?.startdate,
        enddate: this.filterDataRecieved?.enddate,
        parkingLot: this.filterDataRecieved?.parkingLot,
        invoiceNumber: this.filterDataRecieved?.invoiceNumber,
        paymentStatus: this.filterDataRecieved?.paymentStatus,
      })
    }
    this.filterFormGroup.get('paymentStatus')?.setValue(this.filterDataRecieved?.paymentStatus);
  }

  getParkingLotByStatesName() {
    this.superAdminService.getParkingLotByStatesName(null).pipe(autoUnsubWith(this.destroyRef)).subscribe({
      next: (response: ParkingLot[]) => {
        this.parkingLotByStatesList = response;
        this.parkingLotByStatesListWithAll = [...response];
        if (!this.filterDataRecieved?.parkingLot || this.filterDataRecieved.parkingLot.length === 0) {
          this.filterFormGroup.get('parkingLot')?.setValue(this.parkingLotByStatesList.map(lot => lot.id));
        } else {
          const matchedParkingLotIds = this.parkingLotByStatesList
            .filter(lot => this.filterDataRecieved.parkingLot.includes(lot.id))
            .map(lot => lot.id);
  
          this.filterFormGroup.get('parkingLot')?.setValue(matchedParkingLotIds.length > 0 ? matchedParkingLotIds : null);
        }
        
      },
      error: (_err: any) => {
        this.parkingLotByStatesListWithAll = [];
        this.filterFormGroup.get('parkingLot').setValue(null);
        
      }
    })
  }

  onChangePaymentStatus(event: any) {
    this.filterFormGroup.get('paymentStatus').setValue(event.value);
  }
  applyFilter() {
    if (this.isStartdateEndDateValid() && this.filterFormGroup.valid) {
      this.ref.close({ filterData: this.filterFormGroup.value, isResetButton: true });
    }
  }
 
  isStartdateEndDateValid(): boolean {
    this.errorMessage = '';

    const startDate = this.filterFormGroup.get('startdate')?.value;
    const endDate = this.filterFormGroup.get('enddate')?.value;
  
    if ((startDate && !endDate) || (!startDate && endDate)) {
      this.errorMessage = SELECT_BOTH_DATES;
      return false;
    }
  
    if (startDate && endDate && startDate >= endDate) {
      this.errorMessage =  END_DATE_GREATER;
      return false;
    }
  
    return true;
  }

  updateMinEndDate() {
    const startDateValue = this.filterFormGroup.get('startdate')?.value;
    if (startDateValue) {
      this.minEndDate = new Date(startDateValue);
    } else {
      this.minEndDate = null;
    }
  }

  closeModal(){
    this.ref.close();
  }
  onlyNumberInputs(event: KeyboardEvent): void {
    const allowedChars = /[0-9\.]/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }
  }